import cn from "classnames"
import { observer } from "mobx-react"
import { GeneralIcon } from 'modules/common/components/planr/icon/Generalcon'
import { WorkTypeLinkSnapshotType } from "modules/orders-manage/models/order"
import {
    OrderContentTasksDictionaryType,
    OrderContentTasksListSnapshotType
} from "modules/orders-manage/models/order-content-tasks"
import { SectionCollapserType } from "modules/orders-manage/models/orders-store"
import React from "react"
import styles from "./Block.module.scss"
import { TTaskFilePath } from "./CategoryBlock"


export type TUnit = WorkTypeLinkSnapshotType
type TTask = OrderContentTasksListSnapshotType

class BlockBase extends React.PureComponent<BlockProps> {
    private ref = React.createRef<HTMLDivElement>();

    render() {
        const {
            units,
            store,
            onClick,
            selectedUnitGuid
        } = this.props
        return (
            <div ref={this.ref} className={`${styles.block}`}
            >
                {units.length > 0 && (
                    <div className={styles.wrapper}>
                        {units.map((work) => {
                            const contentTask = store.contentTasksList.find(
                                (item) => item.guid === work.unit.guid
                            )
                            let indicatorType = 'none' // 'none', 'unsigned', 'allSigned'

                            if (contentTask && contentTask.resultFiles && contentTask.resultFiles.length > 0) {
                                const resultFiles = contentTask.resultFiles

                                // Группируем файлы по имени и берем последнюю версию
                                const resultFilesByName = resultFiles.reduce((acc, file) => {
                                    if (!acc[file.name]) {
                                        acc[file.name] = []
                                    }
                                    acc[file.name].push(file)
                                    return acc
                                }, {} as Record<string, any[]>)

                                // Берем только последние версии файлов
                                const latestResultFiles = Object.values(resultFilesByName).map((files) =>
                                    files.sort((a, b) => b.version - a.version)[0]
                                )

                                // Проверяем, все ли файлы подписаны
                                const allSigned = latestResultFiles.every((file) => {
                                    if (!file.signatures || file.signatures.length === 0) return false
                                    return file.signatures.every((s: any) => s.signed === true)
                                })

                                // Проверяем, есть ли неподписанные файлы
                                const hasUnsigned = latestResultFiles.some((file) => {
                                    if (!file.signatures || file.signatures.length === 0) return true // файлы без подписантов считаем неподписанными
                                    return file.signatures.some((s: any) => !s.signed)
                                })

                                if (allSigned) {
                                    indicatorType = 'allSigned'
                                } else if (hasUnsigned) {
                                    indicatorType = 'unsigned'
                                }
                            }

                            // const tasksCount = contentTask?.tasks.filter((t) => !t.confirmed).length || 0
                            const isSelected = selectedUnitGuid === work.unit.guid
                            return (
                                <div className={cn(styles.row, {
                                    [styles.selected]: isSelected
                                })} key={work.unit.guid} onClick={() => { onClick(work.unit.guid) }}>
                                    <div className={styles.indicator}>
                                        {/* {tasksCount > 0 && (
                                            <span className={styles.countIndicator}>
                                                {tasksCount}
                                            </span>
                                        )} */}
                                        {indicatorType === 'unsigned' && (
                                            <span className={styles.hasUnsigned}>
                                                <GeneralIcon type="general-exclamation" style={{ marginRight: '4px', color: '#e31818' }} />
                                            </span>
                                        )}
                                        {indicatorType === 'allSigned' && (
                                            <span className={styles.allSigned}>
                                                <GeneralIcon type="general-check" style={{ marginRight: '4px', color: '#1DD278' }} />
                                            </span>
                                        )}
                                    </div>

                                    {/* <div className={styles.orderNumber}>{work.unit.partNumber}</div> */}
                                    <div className={styles.workAndInventory}>{work.unit.name}</div>
                                    <div className={styles.description}>{work.unit.description}</div>
                                    {/* <div className={styles.progress}>
                                        <span
                                            title={work.unit.lastModified ? `Обновлено: ${work.unit.lastModified}` : ""}
                                            className={
                                                work.unit.progress === 0
                                                    ? "percents color-red"
                                                    : work.unit.progress < 50
                                                        ? "percents color-orange"
                                                        : work.unit.progress >= 50 && work.unit.progress < 75
                                                            ? "percents color-blue"
                                                            : work.unit.progress >= 75 && work.unit.progress < 100
                                                                ? "percents color-purple"
                                                                : work.unit.progress === 100
                                                                    ? "percents color-green"
                                                                    : "progress"
                                            }
                                        >
                                            {work.unit.progress} %
                                        </span>
                                    </div> */}
                                </div>
                            )
                        })}
                    </div>
                )}
            </div>
        )
    }


}

export const Block = observer(BlockBase)
export type ActivationDelegate = (unit: TUnit) => void

interface BlockProps {
    category: string
    units: { index: number; unit: TUnit }[]
    onChange: (tasks: TTask[]) => void
    onSort: (from: number, to: number) => void
    touched: boolean
    readOnly: boolean
    store: OrderContentTasksDictionaryType
    baseUrl: string
    orderId: string
    orderName: string
    user: string
    userId: string
    setGuid: (guid: string) => void
    setTaskId: (id: string) => void
    collapserContent: SectionCollapserType
    toggleDeleteShow: () => void
    toggleShowUploadFiles: () => void
    showAddTask: (guid: string) => void
    showDevelopersDialog: (guid: string, fileId: string) => void
    showEditTask: (
        description: string,
        stopDate: string | null,
        file: TTaskFilePath[],
        guid: string,
        employerId: string | null
    ) => void
    highlightRow?: string
    selectedUnitGuid: string | null
    onClick: (guid: string) => void
}


